import React, { Fragment, Component } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button, Label,
    Spinner,
    Progress,
    Table
} from "reactstrap"
import { ConfirmAlert } from '../../../../helpers/ui/alert'
import Select from '../../../../helpers/ui/CustomSelect'
import { AvForm, AvField, AvGroup, AvCheckboxGroup, AvCheckbox, AvInput } from "availity-reactstrap-validation"

import { Link, useHistory, Redirect } from "react-router-dom"

import apiResponse from '../../../../services/apiResponse'
import { cancelToken } from '../../../../services/adapters/kepegawaian/menuService'

import IndexBloc from '../Index/Blocs/IndexBloc'
import CreateBloc from './Blocs/CreateBloc'

class CreateView extends Component {

    createBloc = new CreateBloc()
    indexBloc = new IndexBloc()
    source
    timer
    constructor(props) {
        super(props)
        this.state = {
            list: [],
            dataForm: {},
            isLoading: 0,
            filter: 
                {
                    filter_value: "",
                    page_number: 1,
                    page_size: 20,
                    sort_order: {
                        column: 'work_unit_sort',
                        order: 'asc' 
                    }
                }
        }
    }

    submitData = async () => {
        await this.createBloc.fetchCreate(this.state.dataForm)
    }

    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }



    loadList = async () => {
        const { filter } = this.state
        let offset = (this.state.filter.page_number-1)*this.state.filter.page_size
        const query = {
            uuid: this.props.id,
            search: filter.filter_value,
            limit: filter.page_size,
            offset: offset,
            order: filter.sort_order.column,
            sort: filter.sort_order.order,
            status: 1
        }
        await this.indexBloc.fetchRowTable(query, this.source.token)
    }

    setTokenAPI = () => {
        if (typeof this.source != typeof undefined) {
            this.source.cancel();
        }
        this.source = cancelToken()
        this.loadList()
    }

    handlerOnSubmit = (e, values) => {
        e.preventDefault()
        this.setState({
            dataForm: values,
            confirm: true
        })
    }

    handleSelectInputChange = value => {
        clearTimeout(this.timer)
            
        this.state.filter.filter_value = value
            
        this.timer = setTimeout(() => this.loadList(), 800)
    }

    componentDidMount() {
        this.setTokenAPI()

        this.indexBloc.rowtableChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({ list: result.data.response })
                    break;
                case apiResponse.ERROR:
                    break;
                default:
                    break;
            }
        })

        this.createBloc.createChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })

    }

    componentWillUnmount() {
        this.indexBloc.rowtableChannel?.unsubscribe()
        this.indexBloc.createChannel?.unsubscribe()
    }
 
    render() {
        const { result, total } = this.state.list
        return (
            <Fragment>
                <Container fluid>
                    <Card>
                        <CardBody>
                            <div className="float-end">
                                <Link to={`/master/struktur-organisasi.html`}>
                                    <Button outline color="primary"><i className="uil uil-backward"></i> Kembali</Button>
                                </Link>
                            </div>
                            <CardTitle>Struktur Organisasi</CardTitle>
                            <hr/>
                            <AvForm
                                className="needs-validation"
                                onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                            >
                                <Row className="mb-3">
                                    <Label
                                        className="col-md-2 col-form-label"
                                    >
                                        Struktur Organisasi <span className="text-danger">*</span>
                                    </Label>
                                    <Col md="5">
                                        <AvField
                                            name="work_unit_name"
                                            placeholder="Nama Struktur Organisasi"
                                            errorMessage="Masukkan Struktur Organisasi"
                                            type="text"
                                            className="form-control"
                                            validate={{ required: { value: true } }}
                                        />
                                    </Col>
                                </Row>

                                <Row className="mb-3">
                                    <Label
                                        className="col-md-2 col-form-label"
                                    >
                                        Parent
                                    </Label>
                                    <Col md="4">
                                        <Select 
                                            name="work_unit_parent_uuid"
                                            errorMessage="Pilih Parent Struktur Organisasi"
                                            options={result} 
                                            optionLabel="work_unit_name"
                                            optionValue="work_unit_uuid"
                                            isClearable
                                            placeholder="Pilih Parent Struktur Organisasi (Kosongkan jika ingin dijadikan parent)"
                                            onInputChange={this.handleSelectInputChange}
                                        />
                                    </Col>
                                </Row>

                                <Row className="mb-3">
                                    <Label
                                        className="col-md-2 col-form-label"
                                    >
                                        Urutan Struktur Organisasi
                                    </Label>
                                    <Col md="2">
                                        <AvField
                                            name="work_unit_sort"
                                            placeholder="Urutan Struktur Organisasi"
                                            errorMessage="Masukkan Urutan Struktur Organisasi"
                                            type="number"
                                            className="form-control"
                                        />
                                    </Col>
                                </Row>

                                <Row className="mb-3">
                                    <Col md="3"></Col>
                                    <Col md="9">
                                        <Link to="/master/struktur-organisasi.html">
                                            <Button color="success" type="button"><i className="uil-arrow-left"></i> Kembali</Button>
                                        </Link>
                                        {' '}
                                        <Button color="danger" type="submit">
                                            <i className="uil-arrow-up-right"></i> Simpan Data
                                        </Button>
                                    </Col>
                                </Row>

                            </AvForm>
                        </CardBody>
                    </Card>
                </Container>
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin data tersebut sudah benar?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal disimpan"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.redirect ?
                    <Redirect to='/master/struktur-organisasi.html'/>
                : null }
            </Fragment>
        )
    }
}

export default CreateView
